<template>
  <aside class="promo-config">
    <div class="config-body">
      <section class="config-section">
        <div class="section-row">
          <label class="section-label">视频参数</label>
        </div>

        <div class="ratio-row">
          <div class="ratio-cards">
            <button
              v-for="(item, index) in workbench.ratioOptions"
              :key="item.value"
              class="ratio-card"
              :class="{
                active: item.value === workbench.videoSettings.ratio,
                span2: index < 3,
                span3: index >= 3,
              }"
              @click="workbench.setVideoRatio(item.value)"
            >
              <div
                class="ratio-rect"
                :class="'ratio-' + item.value.replace(':', '-')"
              ></div>
              <div class="ratio-label">{{ item.label || item.value }}</div>
              <div
                v-if="item.value === workbench.videoSettings.ratio"
                class="ratio-check"
              >
                ✓
              </div>
            </button>
          </div>
        </div>

        <div class="count-box">
          <span class="config-card-label">生成时长</span>
          <CustomSelect
            v-model="workbench.videoSettings.duration"
            :options="workbench.durationOptions"
          />
        </div>
      </section>

      <section class="config-section">
        <div class="section-row">
          <label class="section-label">提示词</label>
          <span class="text-dim tiny">同步宣传图提示词</span>
        </div>

        <div class="textarea-wrap">
          <textarea
            v-model="workbench.promo.prompt"
            rows="5"
            class="section-textarea"
            placeholder="描述视频的镜头、风格、节奏..."
          ></textarea>
          <div class="textarea-meta">
            <span class="badge-muted">ZH</span>
            <span class="text-dim tiny"
              >{{ workbench.promo.prompt.length }}/1000</span
            >
          </div>
        </div>

        <label class="switch inline">
          <input v-model="workbench.videoSettings.watermark" type="checkbox" />
          <span class="slider"></span>
          <span class="switch-text">添加水印</span>
        </label>
      </section>
    </div>

    <div class="config-footer">
      <button
        class="primary-btn"
        :disabled="
          workbench.videoGen.loading || !workbench.videoGen.selectedIdxs.length
        "
        @click="workbench.runVideoFromSelection"
      >
        {{ workbench.videoGen.loading ? "生成视频中..." : "生成宣传视频" }}
      </button>
      <p class="footer-hint">
        已选择 {{ workbench.videoGen.selectedIdxs.length || 0 }} 张图
      </p>

      <div class="status-row">
        <span class="status" v-if="workbench.videoGen.error">{{
          workbench.videoGen.error
        }}</span>
        <span
          class="status ok"
          v-if="workbench.videoGen.status && !workbench.videoGen.error"
          >{{ workbench.videoGen.status }}</span
        >
      </div>
    </div>
  </aside>
</template>

<script setup>
import CustomSelect from "@/components/common/CustomSelect.vue";
import { useWorkbenchStore } from "@/stores/useWorkbenchStore";

const workbench = useWorkbenchStore();
</script>
